<template>
  <v-card class="rounded-lg">
    <v-card-title>Editor categories map config</v-card-title>
    <v-toolbar flat color="transparent">
      <v-text-field
        v-model="search"
        :append-icon="mdiMagnify"
        label="Search"
        single-line
        hide-details>
      </v-text-field>
      <v-spacer/>
      <RevisionsDialog
        v-model="revisions"
      />
      <CustomCategoryDialog
        v-model="category"
        :item="editedItem"
        @save="save"
      />
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="categories"
      :search="search"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              class="mr-2"
              @click="editItem(item)"
            >
              {{ mdiPencil }}
            </v-icon>
          </template>
          <span>Edit editor category</span>
        </v-tooltip>
        <v-tooltip
          v-if="item.status == 'visible'"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="green"
              class="mr-2"
              @click="updateItemInfo(item, { status: 'hidden' })"
            >
              {{ mdiEye }}
            </v-icon>
          </template>
          <span>Click to hide category on the map</span>
        </v-tooltip>
        <v-tooltip
          v-else
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="red"
              class="mr-2"
              @click="updateItemInfo(item, { status: 'visible' })"
            >
              {{ mdiEyeOff }}
            </v-icon>
          </template>
          <span>Click to show category on the map</span>
        </v-tooltip>
        <v-tooltip
          v-if="item.event_area_calculation == true"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="green"
              class="mr-2"
              @click="updateItemInfo(item, { event_area_calculation: false })"
            >
              {{ mdiTableRowPlusAfter }}
            </v-icon>
          </template>
          <span>Click to hide event from calculation with area</span>
        </v-tooltip>
        <v-tooltip
          v-else
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="red"
              class="mr-2"
              @click="updateItemInfo(item, { event_area_calculation: true })"
            >
              {{ mdiTableRowRemove }}
            </v-icon>
          </template>
          <span>Click to use event for calculation with area</span>
        </v-tooltip>
        <v-tooltip
          v-if="item.combined_computin == true"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="green"
              class="mr-2"
              @click="updateItemInfo(item, { combined_computin: false })"
            >
              {{ mdiPlaylistPlus }}
            </v-icon>
          </template>
          <span>Click to hide event from  <b>Interactions</b> formula</span>
        </v-tooltip>
        <v-tooltip
          v-else
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              color="red"
              class="mr-2"
              @click="updateItemInfo(item, { combined_computin: true })"
            >
              {{ mdiPlaylistMinus }}
            </v-icon>
          </template>
          <span>Click to use event for <b>Interactions</b> formula</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              class="mr-2"
              @click="openDeleteDialog(item)"
            >
              {{ mdiDelete }}
            </v-icon>
          </template>
          <span>Remove category</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <DeleteDialog
      v-if="deleteDialog"
      :item="deletedItem"
      @close="deleteDialog = false"
      @confirm="deleteItem"
    />
  </v-card>
</template>

<script>
import {
  mdiPencil,
  mdiEye,
  mdiEyeOff,
  mdiMagnify,
  mdiTableRowRemove,
  mdiTableRowPlusAfter,
  mdiPlaylistPlus,
  mdiPlaylistMinus,
  mdiDelete
} from "@mdi/js"

export default {
  components: {
    CustomCategoryDialog: () => import('../../../components/dialogs/CustomCategoryDialog'),
    DeleteDialog: () => import('../../../components/dialogs/DeleteDialog.vue'),
    RevisionsDialog: () => import('../../../components/dialogs/EditorRevisionsDialog')
  },
  data() {
    return {
      mdiPencil,
      mdiEye,
      mdiEyeOff,
      mdiMagnify,
      mdiTableRowRemove,
      mdiTableRowPlusAfter,
      mdiPlaylistPlus,
      mdiPlaylistMinus,
      mdiDelete,
      search: '',
      category: false,
      revisions: false,
      categories: [],
      headers: [
        {
          text: 'Alias',
          value: 'alias',
          sortable: false,
        },
        {
          text: 'Table name',
          value: 'table_name',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Color',
          value: 'color',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
          align: 'center'
        },
      ],
      dafultItem: {
        alias: '',
        table_name: '',
        color_type: 'solid',
        color: '#FFFFFF',
        type: 'point',
        status: 'visible',
        beamOnClick: false,
        beamColor: '#FFFFFF',
        colors_config: {
          minCount: 0,
          maxCount: 0,
          colorsByValue: [
            [0, 'integer', '#FFFFFF']
          ]
        },
        columns: []
      },
      editedItem: {
        alias: '',
        table_name: '',
        color_type: 'solid',
        color: '#FFFFFF',
        type: 'point',
        beamOnClick: false,
        beamColor: '#FFFFFF',
        colors_config: {
          minCount: 0,
          maxCount: 0,
          colorsByValue: [
            [0, 'integer', '#FFFFFF']
          ]
        },
        columns: []
      },
      deleteDialog: false,
      deletedItem: null
    }
  },
  async mounted () {
    let { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/editor/data')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.categories = data
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, { ...item, platforms: { ...this.editedItem.platforms, ...item.platforms }});
      this.category = true;
    },
    async save(item) {
      let { data } = await this.$axios({
        method: item.id ? 'put' : 'post',
        url: this.$store.getters.projectPath + '/configs/editor' + (item.id ? '/' + item.id : ''),
        data: item
      }).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        let index = this.categories.findIndex(category => category.id == data.id);
        if (index !== -1) {
          this.$set(this.categories, index, data);
          this.$toasted.success('Category updated');
        } else {
          this.categories.push(data);
          this.$toasted.success('Category created')
        }
      }
    },
    async updateItemInfo(item, info) {
      let { data } = await this.$axios.put(
        `${this.$store.getters.projectPath}/configs/editor/${item.id}/info`,
        info
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        let index = this.categories.findIndex(category => category.id == data.id);
        if (index !== -1) {
          let category = this.categories.find(category => category.id == data.id);
          this.$set(this.categories, index, { ...category, ...info });
          this.$toasted.success('Info changed')
        }
      }
    },
    async deleteItem (item) {
      let { data } = await this.$axios.delete(
        `${this.$store.getters.projectPath}/configs/editor/${item.id}/${item.table_name}`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        let index = this.categories.findIndex(category => category.id == item.id);
        if (index !== -1) {
          this.$delete(this.categories, index);
          this.$toasted.success('Category deleted')
        }
      }
    },
    openDeleteDialog (item) {
      this.deletedItem = item
      this.deleteDialog = true
    }
  },
  watch: {
    category() {
      if (!this.category) {
        this.$validator.reset();
        this.editedItem = Object.assign({}, { ...this.dafultItem })
      }
    }
  }
}
</script>
